/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import GridItem from "components/Grid/GridItem.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import cardImagesStyles from "assets/jss/material-dashboard-react/cardImagesStyles.jsx";
// @material-ui/icons
import Payment from "@material-ui/icons/Style";
import Amount from "@material-ui/icons/AccountBalanceWalletTwoTone";
import Settlement from "@material-ui/icons/DoneAll";
import Report from "@material-ui/icons/Report";
import Passengers from "@material-ui/icons/AirlineSeatReclineNormal";
//core components
import CardIcon from "components/Card/CardIcon.jsx";
import { primaryColor } from "assets/jss/material-dashboard-react.jsx";
import Faan from 'assets/img/faan_logo.png';
import { Link } from 'react-router-dom';
import "./style.css"
import withMobileDialog from "@material-ui/core/withMobileDialog/index";
import { connect } from "react-redux";
import { appConstants } from "../../_constants";
import Authorization from "../../layouts/Landing/component/Authorization";

const styles = theme => ({
  ...cardImagesStyles,
  textWhite: {
    // boxShadow:'0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    "&, & *": {
      color: "#FFF"
    }
  },
  space: {
    padding: '20px',
    color: 'black'
  },
  title: {
    fontWeight: '500',
    fontFamily: "'Montserrat', sans-serif !important",
    color: "black",
    textTransform: "uppercase",
    fontSize: "40px",
    width: "100%"
    // padding:"15px 0"
  },
  cardTitle: {
    fontWeight: '500'
  },
  root: {
    flexGrow: 1,
    width: '100%',
    height: '100%',
    position: 'absolute',
    bottom: 0,
    background: "url('img/airportabj.jpg')",
    //background:"white",
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  rootOverlay: {
    flexGrow: 1,
    background: "rgba(0,0,0,.75)",
    width: "100%",
    position: "absolute",
    bottom: 0,
    top: 0,
    height: "100%"
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  center: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%'
  },
  center2: {
    paddingTop: ".8rem",
    justifyContent: 'center',
    // alignItems:'center',
    textAlign: 'center',
    width: '100%',
    // marginBottom:"50px"
  },
  card: {
    padding: '1rem 3rem',
    width: "100%"
  },
  checked: {
    color: primaryColor + "!important"
  },
  checkedIcon: {
    width: "20px",
    height: "20px",
    border: "1px solid rgba(0, 0, 0, .54)",
    borderRadius: "3px"
  },
  uncheckedIcon: {
    width: "0px",
    height: "0px",
    padding: "10px",
    border: "1px solid rgba(0, 0, 0, .54)",
    borderRadius: "3px"
  },
  radio: {
    color: primaryColor + "!important"
  },
  radioChecked: {
    width: "20px",
    height: "20px",
    border: "1px solid " + primaryColor,
    borderRadius: "50%"
  },
  radioUnchecked: {
    width: "0px",
    height: "0px",
    padding: "10px",
    border: "1px solid rgba(0, 0, 0, .54)",
    borderRadius: "50%"
  },
  icon: {
    color: '#fff'
  }
  
});

class RegionalReportsLanding extends React.Component {
  state = {
    checked: [],
  };
  handleToggle = value => () => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    
    this.setState({
      checked: newChecked,
    });
  };
  render() {
    
    const { classes, user, setView } = this.props;
    const props_ = {
      styles: styles,
      user: user,
      classes: classes,
      setView: setView
    };
    return (
      <div className={`root ${classes.root}`}>
        <div className={classes.rootOverlay}>
          
          <Authorization {...props_}/>
          
          <Grid container className={classes.center2}>
            <Grid item lg={6} sm={12}>
              <div style={{ margin: '15px 0 20px' }}><img src={Faan} /></div>
            </Grid>
          </Grid>
          
          <Grid container className={classes.center2} style={{ paddingTop: '0' }}>
            <GridItem container lg={10} sm={12}>
              <Grid container className={'col-container'}>
                <Grid item lg={4} sm={12} className={classes.card}>
                  <Card chart>
                    <Link to={setView === "regional" ? "/app/psc-regional/psc-utilization" : "/app/psc-utilization" } className={'animate-card-container'}>
                      <CardHeader  color={setView === "regional" ? "regional" : "success"} className={'animate-card-header'}>
                        <div style={{ textAlign: "center", margin: "0" }}>
                          <Settlement style={{ fontSize: "60px" }} />
                        </div>
                        <h4 style={styles.title}>Token Utilization by Airport</h4>
                      </CardHeader>
                      <CardBody>
                        <p style={{ color: '#000' }}>
                          {/* PSC token usage across all domestic airport in real-time */}
                          Report displays PSC token usage across all domestic airport in real-time
                        </p>
                        <Button
                          type="button"
                          color={setView === "regional" ? "regional" : "primary"}
                        >
                          Explore
                        </Button>
                      </CardBody>
                    </Link>
                  
                  </Card>
                </Grid>
                <Grid item lg={4} sm={12} className={classes.card}>
                  <Card chart>
                    <Link to={setView === "regional" ? "/app/psc-regional/billable-passengers" : "/app/billable-passengers"} className={'animate-card-container'}>
                      <CardHeader color="success" className={'animate-card-header pscSettlement'}>
                        <div style={{ textAlign: "center", margin: "0" }}>
                          <Passengers style={{ fontSize: "60px" }} />
                        </div>
                        <h4 style={styles.title}>Total Passengers Vs Billable Passengers </h4>
                      </CardHeader>
                      <CardBody>
                        <p style={{ color: '#000' }}>
                          Report displays Total vs Billable passengers per month
                        </p>
                        <Button
                          type="button"
                          color="warning"
                        >
                          Explore
                        </Button>
                      </CardBody>
                    </Link>
                  </Card>
                </Grid>
                {
                  (user.AppRole !== appConstants.ROLES.AIRLINE) &&
                  <Grid item lg={4} sm={12} className={classes.card}>
                    <Card chart>
                      <Link to={setView === "regional" ? "/app/psc-regional/transit-passenger-report" : "/app/transit-passenger-report" } className={'animate-card-container'}>
                        <CardHeader color="success" className={'animate-card-header airlinePayment'}>
                          <div style={{ textAlign: "center", margin: "0" }}>
                            <Payment style={{ fontSize: "60px" }} />
                          </div>
                          <h4 style={styles.title}>Transit Passenger <br /> Report </h4>
                        </CardHeader>
                        <CardBody>
                          <p style={{ color: '#000' }}>
                            Number of passengers on transit in a flight
                          </p>
                          <Button
                            type="button"
                            color="info"
                          >
                            Explore
                          </Button>
                        </CardBody>
                      </Link>
                    </Card>
                  </Grid>
                  
                }
                {
                  // (user.AppRole !== appConstants.ROLES.AIRPORT_STAFF) &&
                  // (user.AppRole === appConstants.ROLES.STAFF) &&
                  // (user.AppRole === appConstants.ROLES.VGG_ADMIN) &&
                  (user.AppRole !== appConstants.ROLES.VGG_USER) &&
                  // (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) &&
                  <Grid item lg={4} sm={12} className={classes.card}>
                    <Link to={setView === "regional" ? "/app/psc-regional/statement-of-account" : "/app/statement-of-account"}>
                      <Card>
                        <CardHeader  color={setView === "regional" ? "regional" : "success"} stats icon>
                          <CardIcon  color={setView === "regional" ? "regional" : "success"}>
                            <Amount style={{ fontSize: "60px" }} />
                          </CardIcon>
                          <div className={'landing-mini-header-text'}>
                            Statement Of Account
                          </div>
                        </CardHeader>
                        <CardBody />
                      </Card>
                    </Link>
                  </Grid>
                }
                {
                  // (user.AppRole !== appConstants.ROLES.AIRLINE) &&
                  <Grid item lg={4} sm={12} className={classes.card}>
                    <Link to={setView === "regional" ? "/app/psc-regional/wallet-report" : "/app/wallet-report"}>
                      <Card>
                        <CardHeader  color={setView === "regional" ? "regional" : "success"} stats icon>
                          <CardIcon  color={setView === "regional" ? "regional" : "success"}>
                            <Amount style={{ fontSize: "60px" }} />
                          </CardIcon>
                          <div className={'landing-mini-header-text'}>
                            Airline Wallet Report
                          </div>
                        </CardHeader>
                        <CardBody />
                      </Card>
                    </Link>
                  </Grid>
                }
                { (user.AppRole !== appConstants.ROLES.VGG_SUPERADMIN) &&
                (user.AppRole !== appConstants.ROLES.VGG_USER) &&
                <Grid item lg={4} sm={12} className={classes.card}>
                  <Link to={setView === "regional" ? "/landing" : "/landing"}>
                    <Card>
                      <CardHeader color="warning" stats icon>
                        <CardIcon color="warning">
                          <Report />
                        </CardIcon>
                        <div className={'landing-mini-header-text'}>
                          Home
                        </div>
                      </CardHeader>
                      <CardBody />
                    </Card>
                  </Link>
                </Grid>}
              </Grid>
            
            </GridItem>
          
          </Grid>
        </div>
      </div>
    )
  }
}

RegionalReportsLanding.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { user, setView } = state;
  return {
    user,
    setView
  };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(styles)(RegionalReportsLanding)));



// WEBPACK FOOTER //
// ./src/layouts/recordsLanding/regional-reports-landing.js